/**
 * @flow
 */
'use strict';

export const posteriorLensCodes = [[
  {"code":"90D"},
  {"code":"78D"},
  {"code":"20D"},
  {"code":"Super 66"},
],
[
  {"code":"DO"},  //Direct ophthalmo-scopy
  {"code":"MIO"}, //monucular indirect ophthalmo-scopy
  {"code":"BIO"}  //binocular indirect ophthalmo-scopy
]]


export const vitreousCodes = [
{"code":"Clear"},
{"code":"PVD"},
{"code":"Floaters"},
{"code":"Syneresis"}
]

export const opticDiscCodes = [[
  {"code":"Pink"},
  {"code":"Pale"},
  {"code":"Drusen"},
],[
  {"code":" / Normal size"},
  {"code":" / Small"},
  {"code":" / Large"}
],[
  {"code":" / ISNT"},
  {"code":" / No ISNT"}
]]

export const cdrCodes = [
{"code":"WNL"}
]

export const vesselsCodes = [
{"code":"WNL"},
{"code":"A/V crossing change"},
{"code":"2:3 A/V Ratio"},
{"code":"Dilation"},
{"code":"Venous beading"},
{"code":"Tortuosity"}
]

export const maculaCodes = [
{"code":"No maculopathy"},
{"code":"Diabetic maculopathy"},
{"code":"Microaneurysms"},
{"code":"Dot and Blot hemorrhages"},
{"code":"Flame haemorrhages"},
{"code":"Hard Exudates"},
{"code":"Soft Exudates/CWS"},
{"code":"DME"},
{"code":"RPE changes"},
{"code":"Macular hole"},
{"code":"CME"},
{"code":"CSME"}
]

export const retinaCodes = [
{"code":"WNL"},
{"code":"No diabetic maculopathy"},
{"code":"Drusen"},
]

export const peripheryCodes = [
{"code":"WNL"},
{"code":"Choroidal Nevus"},
{"code":"Pavingstone degeneration"},
{"code":"WWP"},
{"code":"Lattice degeneration"},
{"code":"Retinal hole"},
{"code":"Retinal tear"},
{"code":"Retinal detachment"}
]

export const pupillaryReflexCodes = [
{"code":"Clear"},
{"code":"Dull"},
{"code":"None"}
]
